import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';
import { useAdminWorkspace } from './AdminWorkspaceProvider';
import { companyWorkersPath } from './tenantWorkspace';

const LegacyWorkersRoute = ({ children }: { children: ReactNode }) => {
  const state = useAdminWorkspace();

  if (state.kind === 'company') {
    if (state.status !== 'ready') return <SuspenseLoader />;
    return <Navigate to={companyWorkersPath(state.workspace)} replace />;
  }

  return <>{children}</>;
};

export default LegacyWorkersRoute;
